import type {
    CommerceEvent,
    CommerceEventListener,
    CommerceEventName,
    CommerceEventOf,
    CommerceEventsDomain,
    CommerceEventUnsubscribe,
    CommerceNamedEventListener,
} from "@teqtank/commerce-contracts";
import { DisposableListenerRegistry } from "./disposable-listener-registry.js";

export class CommerceEventHub implements CommerceEventsDomain {
    private readonly listeners = new DisposableListenerRegistry<CommerceEvent>();

    public on(listener: CommerceEventListener): CommerceEventUnsubscribe;
    public on<TName extends CommerceEventName>(
        name: TName,
        listener: CommerceNamedEventListener<TName>,
    ): CommerceEventUnsubscribe;
    public on<TName extends CommerceEventName>(
        nameOrListener: TName | CommerceEventListener,
        listener?: CommerceNamedEventListener<TName>,
    ): CommerceEventUnsubscribe {
        if (typeof nameOrListener === "function") return this.listeners.subscribe(nameOrListener);
        if (listener === undefined)
            throw new TypeError("A named Commerce event listener is required.");
        return this.listeners.subscribe((event) => {
            if (event.name === nameOrListener) listener(event as CommerceEventOf<TName>);
        });
    }

    public emit(event: CommerceEvent): void {
        this.listeners.emit(Object.freeze(event));
    }

    public release(): void {
        this.listeners.release();
    }
}
